import { Grid } from "@mui/material";
import React from "react";
import { formatOutput } from "../../../utils/computation/analysis";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

function TwoSampleTTestResult({ result }) {
  return (
    <div>
      <GraphHeader
        column={result.column}
        dateTime={result.dateTime}
        title={result.title}
        analysisId={result.id}
        graphs={result.graphs}
        additionals={{
          confidenceLevel: result.confidenceLevel,
        }}
      />
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ color: "#535353" }}
      >
        <Grid item xs={2.4} sm={2.4} md={2.4}>
          <h4>Data</h4>
          <h3>Column A</h3>
          <h3>Column B</h3>
        </Grid>
        <Grid item xs={2.4} sm={2.4} md={2.4}>
          <h4>N</h4>
          <h3>{result.arr1.n}</h3>
          <h3>{result.arr2.n}</h3>
        </Grid>
        <Grid item xs={2.4} sm={2.4} md={2.4}>
          <h4>Mean</h4>
          <h3>{formatOutput(result.arr1.mean)}</h3>
          <h3>{formatOutput(result.arr2.mean)}</h3>
        </Grid>
        <Grid item xs={2.4} sm={2.4} md={2.4}>
          <h4>StDev</h4>
          <h3>{formatOutput(result.arr1.std)}</h3>
          <h3>{formatOutput(result.arr2.std)}</h3>
        </Grid>
        <Grid item xs={2.4} sm={2.4} md={2.4}>
          <h4>StMean</h4>
          <h3>{formatOutput(result.arr1.statsem)}</h3>
          <h3>{formatOutput(result.arr2.statsem)}</h3>
        </Grid>

        <Grid item xs={4} sm={4} md={4}>
          <h4>Difference</h4>
          <h3>{formatOutput(result.difference)}</h3>
        </Grid>
        <Grid item xs={8} sm={8} md={8}>
          {/* <h4>95% CI for u</h4>
          <h3>(99,999.99 , 99,999.99)</h3>
          <h4>Note: u is the population mean of Column A</h4> */}
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>Hypothesis Test</h4>
          <h4>Null hypothesis</h4>
          <h4>
            H<sub>0</sub>: U<sub>1</sub> - U<sub>2</sub> = 0
          </h4>
        </Grid>

        <Grid item xs={9} sm={9} md={9}>
          <br />
          <h4>Alternative hypothesis</h4>
          <h4>
            H<sub>1</sub>: U<sub>1</sub> - U<sub>2</sub> ≠ 0
          </h4>
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>T-Value</h4>
          <h3>{formatOutput(result.twoSampleTtest.statistic)}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>DF</h4>
          <h3>{formatOutput(result.difference)}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>P-Value</h4>
          <h3>{formatOutput(result.twoSampleTtest.pvalue)}</h3>
        </Grid>
      </Grid>
      {result.graphs.isBoxplot && result.boxPlotResult && (
        <ImageGraph
          url={result.boxPlotResult.groupBoxplot}
          title="BoxPlot"
          column={result.column}
          // percent={result.inputs.confindence * 100}
          percent={95}
        />
      )}

      {result.graphs.isIVP && result.ivpResult && (
        <ImageGraph
          url={result.ivpResult.individualPlot}
          title="Individual Value Plot"
          column={result.column}
          // percent={result.inputs.confindence * 100}
          percent={95}
        />
      )}

      <Grid item xs={12} sm={12} md={12}>
        <h4>{result?.conclusion}</h4>
      </Grid>
    </div>
  );
}

export default TwoSampleTTestResult;
